const STATUS_STYLES = {
  // ServiceRequest
  new: "bg-amber-100 text-amber-900 border-amber-300",
  triage: "bg-sky-100 text-sky-900 border-sky-300",
  scheduled: "bg-emerald-100 text-emerald-900 border-emerald-300",
  converted: "bg-slate-100 text-slate-700 border-slate-300",
  closed: "bg-slate-200 text-slate-600 border-slate-400",
  canceled: "bg-rose-100 text-rose-800 border-rose-300",
  // WorkOrder extra
  draft: "bg-slate-100 text-slate-600 border-slate-300",
  assigned: "bg-amber-100 text-amber-900 border-amber-300",
  en_route: "bg-blue-100 text-blue-900 border-blue-300",
  on_site: "bg-emerald-200 text-emerald-900 border-emerald-400",
  paused: "bg-orange-100 text-orange-900 border-orange-300",
  completed: "bg-emerald-100 text-emerald-800 border-emerald-300",
  // Priority
  low: "bg-slate-100 text-slate-700 border-slate-300",
  normal: "bg-sky-100 text-sky-900 border-sky-300",
  high: "bg-amber-100 text-amber-900 border-amber-300",
  urgent: "bg-rose-100 text-rose-900 border-rose-400",
};

export default function StatusBadge({ value, className = "" }) {
  if (!value) return null;
  const style =
    STATUS_STYLES[value] ||
    "bg-slate-100 text-slate-700 border-slate-300";
  return (
    <span
      data-testid={`status-badge-${value}`}
      className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ${style} ${className}`}
    >
      {String(value).replace(/_/g, " ")}
    </span>
  );
}
